module.exports = __webpack_public_path__ + "static/media/watches.0c18f210.jpg";